import { connect, mapProps } from '@formily/react'
import { FileUpload } from '../ui/file-upload'

export const FormilyUploader = connect(
  FileUpload,
  mapProps((props) => {
    return {
      ...props,
      value: props.value,
    }
  }),
)
